import { useQuery } from '@tanstack/react-query';
import { Interval } from 'luxon';

import { getCampaignsPerformancePerDay } from 'apis/merchant-gateway/insights/campaigns-performance/split/api';
import { AnalyticsAPICampaignType } from 'apis/merchant-gateway/insights/campaigns-performance/types';
import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { EntityType } from 'common/types';

import { DateRange } from '../types';

export const useCampaignPerformancePerDay = ({
  entityType,
  entityId,
  campaign,
  dateRange,
  enabled = true,
}: {
  entityType: Extract<EntityType, 'venue' | 'merchant'>;
  entityId: string;
  campaign: { campaignId: string; campaignType: CampaignType };
  dateRange: DateRange;
  enabled?: boolean;
}) => {
  const { data, isError, isInitialLoading, isFetching } = useQuery(
    ['insights/campaign-performance/split', entityType, entityId, campaign.campaignId, dateRange.from, dateRange.to],
    () =>
      getCampaignsPerformancePerDay(
        entityType,
        entityId,
        Interval.fromDateTimes(dateRange.from, dateRange.to),
        campaign.campaignId,
        campaign.campaignType === CampaignType.ADS ? AnalyticsAPICampaignType.AD : AnalyticsAPICampaignType.PROMOTION,
      ),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      keepPreviousData: true,
      staleTime: 24 * 60 * 60 * 1000, // 24h
      enabled: !!entityId && enabled,
    },
  );

  return { isError, isInitialLoading, isFetching, campaignPerformancePerDay: data?.data };
};
